import { Autocomplete, AutocompleteItem, Input, Switch } from '@heroui/react'
import MultiInput from 'components/Hero/MultiInput'
import VoiceSelect from 'components/Hero/VoiceSelect'
import { Controller, useFormContext } from 'react-hook-form'
import { ColorPickerField } from './ColorPickerField'
import CopyWidgetCode from './CopyWidgetCode'

export function WidgetSettings({ pathways, isLoadingPathways, widgetId }) {
  const { control, register, formState: { errors } } = useFormContext()
  return (
    <div className="flex flex-col gap-6 pb-4">
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-0.5">
          <span className="text-sm font-medium">Code Snippet</span>
          <div className="text-xs text-gray-500">Copy the code snippet below to and add it to the header of your website.</div>
        </div>
        <CopyWidgetCode widgetId={widgetId} />
      </div>
      <div className="flex flex-col gap-2">
        <MultiInput
          name="allowedDomains"
          label="Allowed Domains"
          description="Only the selected domains will be able to connect to this widget."
          labels={{
            add: 'Add Domain',
            remove: 'Remove',
          }}
        />
      </div>

      <div className="flex w-full gap-2">
        <div className="flex w-full flex-col gap-2">
          <span className="text-sm font-medium">Pathway</span>
          <Controller
            control={control}
            name="pathwayId"
            rules={{ required: '* Pathway is required' }}
            render={({ field }) => (
              <Autocomplete
                radius="none"
                isLoading={isLoadingPathways}
                isInvalid={!!errors.pathwayId}
                errorMessage={errors.pathwayId?.message}
                variant="bordered"
                defaultItems={pathways}
                placeholder="Search a pathway"
                defaultSelectedKey={field.value}
                onSelectionChange={field.onChange}
              >
                {item => <AutocompleteItem key={item.id}>{item.name}</AutocompleteItem>}
              </Autocomplete>
            )}
          />
        </div>

        <Controller
          control={control}
          name="voice"
          render={({ field }) => (
            <div className="w-full">
              <VoiceSelect onChange={field.onChange} value={field.value} />
            </div>
          )}
        />
      </div>

      <div className="flex flex-col gap-2">
        <span className="text-sm font-medium">Widget Icon</span>
        <Input radius="none" placeholder="Enter icon URL" variant="bordered" {...register('widgetIcon')} />
        <p className="text-xs text-gray-500">Leave empty to use default icon</p>
      </div>

      <div className="flex flex-col gap-2">
        <span className="text-sm font-medium">Header content</span>
        <Input radius="none"placeholder="Enter a URL or text" variant="bordered" {...register('headerContent')} />
        <p className="text-xs text-gray-500">Either text, or a URL to display an image</p>
      </div>

      <div className="flex flex-col gap-2">
        <span className="text-sm font-medium">Hide Footer</span>
        <Controller
          name="hideFooter"
          control={control}
          render={({ field }) => {
            return <Switch radius="none" size="sm" checked={field.value} onValueChange={field.onChange} />
          }}
        />
      </div>

      <div className="flex flex-col gap-2">
        <span className="text-sm font-medium">Colors</span>
        <div className="flex w-fit gap-2">
          <ColorPickerField name="primaryColor" label="User Message Color" />
          <ColorPickerField name="secondaryColor" label="Button Color" />
        </div>
      </div>

    </div>
  )
}
